import { render, staticRenderFns } from "./Criteria.vue?vue&type=template&id=28088b87&scoped=true&"
import script from "./Criteria.vue?vue&type=script&lang=js&"
export * from "./Criteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28088b87",
  null
  
)

export default component.exports